import * as React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import './MainMenu.scss';
import { usePermissions } from 'client/components/auth/AuthModule';
import { useCurrentMenuKey } from 'client/core/router/breadcrumb/BreadcrumbContext';
import { useDispatch } from 'react-redux';
import { UserActionsMenu } from 'client/components/auth/login/UserActionsMenu';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { IntlLanguageSelector } from 'client/core/intl/IntlLanguageSelector';
import { useTranslation } from 'react-i18next';

export interface MainMenuProps {}

/**
 * Menu principale dell'applicazione
 */
export function MainMenu(props: MainMenuProps) {
  const currentPathKey = useCurrentMenuKey();
  const theme = useThemeConfig();
  const permissions = usePermissions();
  const { options, labels } = useThemeConfig();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      className="main-menu"
      selectedKeys={currentPathKey}
      style={{ lineHeight: '36px' }}
    >
      <Menu.Item key="domande">
        <Link to="/">{t('menu.procedures.title', 'Istanze')}</Link>
      </Menu.Item>

      {permissions.has('request.read:own') && (
        <Menu.Item key="richieste">
          <Link to="/richieste">
            {t('menu.requests.title', 'Le mie Istanze')}
          </Link>
        </Menu.Item>
      )}

      {permissions.has('pdnd.c020-verify') && (
        <Menu.Item key="pdnd-c020">
          <Link to="/pdnd/accertamenti-c020">
            {t('menu.pdnd.title', 'Accertamento Residenza')}
          </Link>
        </Menu.Item>
      )}

      {!theme.options.hideCELink && (
        <Menu.Item key="external">
          <a href="https://europa.eu/european-union/index_it" target="_blank">
            Link CE
          </a>
        </Menu.Item>
      )}

      <IntlLanguageSelector />

      <UserActionsMenu />
    </Menu>
  );
}
